import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const CHORD_TIMEOUT = 1000;

const ROUTES: Record<string, string> = {
  h: '/',
  s: '/sessions',
  p: '/players',
  t: '/statistics',
  e: '/settlement',
};

export function useKeyboardShortcuts() {
  const navigate = useNavigate();
  const pendingG = useRef(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const tag = (e.target as HTMLElement)?.tagName?.toLowerCase();
      if (tag === 'input' || tag === 'textarea' || (e.target as HTMLElement)?.isContentEditable) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;

      const key = e.key.toLowerCase();

      if (pendingG.current) {
        pendingG.current = false;
        if (timerRef.current) clearTimeout(timerRef.current);
        if (ROUTES[key]) {
          e.preventDefault();
          navigate(ROUTES[key]);
        }
        return;
      }

      if (key === 'g') {
        pendingG.current = true;
        timerRef.current = setTimeout(() => { pendingG.current = false; }, CHORD_TIMEOUT);
      }
    };

    window.addEventListener('keydown', handler);
    return () => {
      window.removeEventListener('keydown', handler);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [navigate]);
}
